// src/stone/icons/SwapHorizontal.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SwapHorizontal = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M22 18H7v-2h15z" }),
      /* @__PURE__ */ jsx("path", { d: "M18 11.586 23.414 17 18 22.414 16.586 21l4-4-4-4zM2 6h16v2H2z" }),
      /* @__PURE__ */ jsx("path", { d: "m7.414 3-4 4 4 4L6 12.414.586 7 6 1.586z" })
    ]
  }
);
var SwapHorizontal_default = SwapHorizontal;

export {
  SwapHorizontal_default
};
